'use strict';

var _ = require('lodash');
var FieldNameTranslationService = function FieldNameTranslationService() {
  var fields = require('../config/adjustmentFieldDisplayNames.json');
  var flattenedFields = _.chain(fields).map(function (value) {
    return value;
  }).transform(function (result, value) {
    _.forEach(value, function (fieldLabel, fieldName) {
      result[fieldName] = fieldLabel;
    });
  }, {}).value();
  var invertedFlattenedFields = _.invert(flattenedFields);
  function nameToLabel(fieldName) {
    return flattenedFields[fieldName];
  }
  function labelToName(fieldLabel) {
    return invertedFlattenedFields[fieldLabel];
  }
  function getAllFields(domain) {
    return _.map(fields[domain], function (value, key) {
      return {
        fieldName: key,
        fieldLabel: value
      };
    });
  }
  return {
    nameToLabel: nameToLabel,
    labelToName: labelToName,
    getAllFields: getAllFields
  };
};
FieldNameTranslationService.$inject = [];
module.exports = FieldNameTranslationService;